import React from 'react';
import PropTypes from 'prop-types';
import { Marker } from 'react-leaflet-universal';

import image from './selskap-gul-42x49px.svg';

const icon = () => {
    if(typeof window === 'undefined') return {};

    const L = require('leaflet');

    return L.divIcon({
        html: `<img src="${image}" />`,
        className: 'department-marker',
        iconAnchor: [21,49],
        iconSize: [42,49]
    });
};

const DepartmentMarker = ({ position }) => (
    <Marker icon={icon()} position={position} />
);

DepartmentMarker.propTypes = {
    position: PropTypes.array,
};

export default DepartmentMarker;



// WEBPACK FOOTER //
// ./src/components/DepartmentMarker/DepartmentMarker.jsx